import httpClient from '../../global/httpClient';
import * as apis from '../../constants/api';

export const getEvents = () => httpClient.get(apis.GET_EVENTS);
export const addToFavoriteList = (payload) =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });
export const getBeforeMock = (payload) =>
  httpClient.get(`${apis.GET_BEFORE_MOCK_DATA}/${payload.paperId}`);
export const getRedoBeforeMock = ({ paperId }) =>
  httpClient.get(apis.getRedoBeforeMock({ paperId }));
export const getMockData = (payload) => httpClient.get(`${apis.GET_MOCK_DATA}/${payload.paperId}`);
export const submitMock = (payload) => httpClient.post(`${apis.POST_MOCK_SUBMIT}`, { ...payload });
export const getQuestion = (paperId, questionId) =>
  httpClient.get(`${apis.GET_MOCK_QUESTION}/${paperId}/${questionId}`);
export const answer = (payload) =>
  httpClient.post(apis.POST_MOCK_QUESTION_ANSWER, { ...payload }, { ignore: true });
export const pauseVoice = (payload) =>
  httpClient.post(apis.POST_MOCK_VOICE_PAUSE, { ...payload }, { ignore: true });
export const finishVoice = (payload) =>
  httpClient.post(apis.POST_MOCK_VOICE_FINISH, { ...payload }, { ignore: true });
